import { Paths } from 'src/constants/paths'
import { createApiClient } from 'src/lib/api-client'

import { getAccount } from '../api'

export const useHandleCheckLoginPasswordExpired = () => {
  const handleCheckLoginPasswordExpired = async () => {
    const account = await getAccount()
    // SSOユーザーの場合はパスワード管理はないので不要
    if (account.loginMethod !== 'Password') {
      return false
    }
    const res = await createApiClient({
      path: '/accounts/profile',
      httpMethod: 'get',
      params: {},
    }).request()

    if (res.result === 'error') {
      return false
    }

    const requireChangePassword = res.data.isPasswordExpired ?? false
    if (requireChangePassword) {
      window.location.href = Paths.ChangePassword
    }
    return requireChangePassword
  }
  return { handleCheckLoginPasswordExpired }
}
